import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import BplsDashboardChartContainerE2E from './containers/BplsDashboardChartContainerE2E';
import DashboardMapContainer from './containers/DashboardMapContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({
  totalStats,
  getTotalStatsE2E,
  getMapDataE2E,
  mapData,
}) {
  const permissions = getJson('permissions');

  const returnNewTransactionData = () => {
    const data = _.get(totalStats, 'item');

    if (Acl(permissions, ['EBPLS BPLO - DASHBOARD'])) {
      return {
        label: 'New',
        total: _.get(totalStats, 'item.New', 0),
        list: [
          {
            label: 'Pending',
            value: _.get(data, 'Pending', 0),
            borderClassName: 'waiting',
          },
          {
            label: 'Ongoing',
            value: _.get(data, 'Ongoing', 0),
            borderClassName: 'waiting',
          },
          {
            label: 'Verified',
            value: _.get(data, 'Verified', 0),
            borderClassName: 'paid',
          },
          {
            label: 'Rejected',
            value: _.get(data, 'Rejected', 0),
            borderClassName: 'rejected',
          },
          {
            label: 'Waiting For Payment',
            value: _.get(data, 'Waiting for payment', 0),
            borderClassName: 'waiting',
          },
          {
            label: 'Cancelled',
            value: _.get(data, 'Cancelled', 0),
            borderClassName: 'rejected',
          },
          {
            label: 'Assessed by Planning Department',
            value: _.get(data, 'Assessed by Planning Department', 0),
            borderClassName: 'checking',
          },
          {
            label: 'Assessed by Engineering Department',
            value: _.get(data, 'Assessed by Engineering Department', 0),
            borderClassName: 'checking',
          },
          {
            label: 'Assessed by BPLO',
            value: _.get(data, 'Assessed by BPLO', 0),
            borderClassName: 'checking',
          },
          {
            label: 'Paid',
            value: _.get(data, 'Paid', 0),
            borderClassName: 'paid',
          },
        ],
      };
    }
    if (Acl(permissions, ['EBPLS PLANNING DEPARTMENT - DASHBOARD'])) {
      return {
        label: 'New',
        total: _.get(totalStats, 'item.New', 0),
        list: [
          {
            label: 'Pending',
            value: _.get(data, 'Pending', 0),
            borderClassName: 'waiting',
          },
          {
            label: 'Verified',
            value: _.get(data, 'Verified', 0),
            borderClassName: 'paid',
          },
          {
            label: 'Rejected',
            value: _.get(data, 'Rejected', 0),
            borderClassName: 'rejected',
          },
          {
            label: 'Assessed by Planning Department',
            value: _.get(data, 'Assessed by Planning Department', 0),
            borderClassName: 'checking',
          },
        ],
      };
    }

    if (Acl(permissions, ['EBPLS ENGINEERING DEPARTMENT - DASHBOARD'])) {
      return {
        label: 'New',
        total: _.get(totalStats, 'item.New', 0),
        list: [
          {
            label: 'Pending',
            value: _.get(data, 'Pending', 0),
            borderClassName: 'waiting',
          },
          {
            label: 'Verified',
            value: _.get(data, 'Verified', 0),
            borderClassName: 'paid',
          },
          {
            label: 'Rejected',
            value: _.get(data, 'Rejected', 0),
            borderClassName: 'rejected',
          },
          {
            label: 'Assessed by Planning Department',
            value: _.get(data, 'Assessed by Planning Department', 0),
            borderClassName: 'checking',
          },
          {
            label: 'Assessed by Engineering Department',
            value: _.get(data, 'Assessed by Engineering Department', 0),
            borderClassName: 'checking',
          },
        ],
      };
    }

    return {
      label: 'New',
      total: _.get(totalStats, 'item.New', 0),
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'Pending', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'Waiting for payment', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'Expired Reference Number', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'Cancelled', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'New',
          value: _.get(data, 'New', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Verified',
          value: _.get(data, 'Verified', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'Rejected', 0),
          borderClassName: 'rejected',
        },
      ],
    };
  };

  const returnRenewTransactionData = () => {
    const data = _.get(totalStats, 'item');

    return {
      label: 'Renewal',
      total: _.get(totalStats, 'item.Renewal', 0),
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'Renewal Pending', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Ongoing',
          value: _.get(data, 'Renewal Ongoing', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Verified',
          value: _.get(data, 'Renewal Verified', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Rejected',
          value: _.get(data, 'Renewal Rejected', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'Renewal Waiting for payment', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'Renewal Cancelled', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Assessed by BPLO',
          value: _.get(data, 'Renewal Assessed by BPLO', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Paid',
          value: _.get(data, 'Renewal Paid', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStatsE2E();
    getMapDataE2E();
  }, []);

  return (
    <div className="container-fluid mb-3 pt-4">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnNewTransactionData()}
            className="mb-3"
          />
          {Acl(permissions, ['EBPLS BPLO - DASHBOARD']) && (
            <DashboardListCard
              data={returnRenewTransactionData()}
              className="mb-3"
            />
          )}
        </div>
        <div className="col-8 pr-0">
          {/* todo:  create and replace this with BplsDashboardChartContainerE2EE2E for e2e dashboard component */}
          <BplsDashboardChartContainerE2E />
          <DashboardMapContainer data={mapData} />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStatsE2E: PropTypes.instanceOf(Function).isRequired,
  getMapDataE2E: PropTypes.instanceOf(Function).isRequired,
  mapData: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS_E2E}`) || {},
  mapData: _.get(api, `${c.GET_MAP_DATA_E2E}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
